import React, { useEffect, useState } from "react";
// import Draggable from "react-draggable";
// import "react-resizable/css/styles.css";
import DialPadButton from "./DialPadButton";
import { useDispatch, useSelector } from "react-redux";
import { SessionState } from "sip.js";
import OngoingScreen from "./OngoingScreen";
import {
  closeModal,
  closeSubModal,
  setSubModal,
} from "../../features/modal/ModalSlice";

import ConnectingScreen from "./ConnectingScreen";
import { getObjectCount } from "../../utils/sipUtilsFunc";
import { PiChats } from "react-icons/pi";
import AgentSettingsWidget from "../Widget/AgentSettingsWidget";
// import { ResizableBox } from "react-resizable";

const DraggablePad = () => {
  const { sessionState, sessions } = useSelector((state) => state.SIPCalls);
  const modal = useSelector((state) => state?.modal?.modal);
  const userInfo = useSelector((state) => state.userInfo.user);

  const dispatch = useDispatch();

  useEffect(() => {
    console.log(sessionState);
  }, [sessionState]);

  const toggleActivitie = () => {
    if (modal?.subModal?.type === "ACTIVITY") dispatch(closeSubModal());
    else dispatch(setSubModal({ type: "ACTIVITY" }));
  };

  const handleClose = () => {
    dispatch(closeModal());
  };

  return (
    <>
      <div className="dialBox">
        {/* {!(sessionState === SessionState.Established) &&
          !(sessions && getObjectCount(sessions) > 0) && ( */}
        <>
          <div className="mb-1 d-flex justify-content-between align-items-center">
            <button
              className={`activitieBtn ${
                modal?.subModal?.type === "ACTIVITY" ? "activeActivity" : ""
              }`}
              onClick={toggleActivitie}
              title="previous activities"
            >
              <span className="me-2">
                <PiChats />
              </span>
              Activities
            </button>

            {userInfo?.is_demo_account && <AgentSettingsWidget />}
          </div>
        </>
        {/* )} */}
        {sessionState === SessionState.Established ? (
          <OngoingScreen />
        ) : sessions && getObjectCount(sessions) > 0 ? (
          <ConnectingScreen />
        ) : (
          <DialPadButton />
        )}
      </div>
    </>
  );
};

export default DraggablePad;
